<template>
    <v-container>
        <v-label>{{$t('company.create')}}</v-label>
        <v-form ref="form"
                v-model="isFormValid">
            <v-container>
                <v-row>
                    <v-text-field outlined
                                  :label="$t('company.name')"
                                  :placeholder="$t('company.name')"
                                  v-model="company.name"
                                  :rules="nameRules"></v-text-field>
                </v-row>
                <v-row>
                    <v-text-field outlined
                                  :label="$t('company.domain')"
                                  :placeholder="$t('company.domain')"
                                  v-model="company.domain"
                                  :rules="domainRules"></v-text-field>
                </v-row>
            </v-container>
        </v-form>
        <v-row>
            <v-col>
                <v-btn color="primary" @click="saveCompany" :disabled="!isFormValid">
                    {{$t('company.create')}}
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {ref} from '@vue/composition-api'

    export default {
        name: 'CompanyAdd',
        setup(props, {root}) {
            const {Company} = root.$FeathersVuex.api;
            const company = new Company();

            const nameRules = ref([
                value => !!value || 'Required',
            ]);

            const domainRules = ref([
                value => !!value || 'Required',
            ]);

            const isFormValid = ref(false);

            const saveCompany = () => {
                company.save().then(() => {
                    root.$router.replace({name: 'company-list'});
                }, root.$handleFeatherError.bind(root));
            };

            return {
                company,
                nameRules,
                domainRules,
                isFormValid,
                saveCompany,
            }
        },
    }
</script>